import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import StandardMenu from '../../../Dropdown/Preset/StandardMenu';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import { getTransKeyForMediaSourceType } from './_helpers';
import s from './MediaSourceMenu.scss';
var enhance = compose(withCurrentMediaSource);
export var MediaSourceMenu = function (_a) {
    var currentMediaSource = _a.currentMediaSource, mediaSourceTypes = _a.mediaSourceTypes, changeCurrentMediaSource = _a.changeCurrentMediaSource;
    var t = useTranslation().t;
    return (React.createElement(StandardMenu, { className: s['root'], lightText: true, withCardWrapper: false, items: mediaSourceTypes.map(function (mediaSourceType) { return ({
            label: t(getTransKeyForMediaSourceType(mediaSourceType)),
            className: mediaSourceType === currentMediaSource
                ? s['bold-menu-item']
                : s['menu-item'],
            onClick: function () { return changeCurrentMediaSource(mediaSourceType); },
        }); }) }));
};
MediaSourceMenu.displayName = 'MediaSourceMenu';
export default enhance(MediaSourceMenu);
//# sourceMappingURL=MediaSourceMenu.connected.js.map